import { MapsCommandsState } from '@redux/maps/mapsCommands.reducer';
import { RootState } from '@redux/store';
import { createSelector } from '@reduxjs/toolkit';

import { OperationalMapId } from '@/types/map.types';

function selectMapsCommands(state: RootState): MapsCommandsState {
  return state.mapsCommands;
}

export const selectMapCommandByMapId = createSelector(
  [selectMapsCommands, (_: RootState, mapId: OperationalMapId) => mapId],
  (state, mapId) => state.entities[mapId],
);
